import { render, staticRenderFns } from "./community-detail.vue?vue&type=template&id=50e1dec7&scoped=true&"
import script from "./community-detail.vue?vue&type=script&lang=js&"
export * from "./community-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e1dec7",
  null
  
)

export default component.exports